import { render, staticRenderFns } from "./AreYouSureModal.vue?vue&type=template&id=462022d0&"
import script from "./AreYouSureModal.vue?vue&type=script&lang=js&"
export * from "./AreYouSureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports